import axios from "axios";
import ElementUI from "element-ui";
import { MessageBox } from "element-ui";
import Router from "@/router/index"; //import 'nprogress/nprogress.css'
import EncryptProxyClient from "./encrypt-proxy-client";
// import nProgress from "nprogress";
// import store from '../store/index';

// const BASEUrl = {
//   // 测试环境
//   // 创建axios实例
//   baseurOne: "https://newkhyapit.tibosi.com", // http://121.40.220.32:8202
//   // baseurTwo: "http://121.40.239.133:8088", // 旧的 2024/9/23
//   baseurTwo: "https://exportwordt.tibosi.com",
//   baseurTwos: "https://exportwordt.tibosi.com",
//   //导出试卷的实例
//   baseurThree: "https://verifycode.tibosi.com",
//   baseurFour: "http://121.40.220.32:8084",
//   baseurFive: "http://121.40.220.32:8002",
//   baseTraining: "http://121.40.220.32:8084/operation-service",
//   baseurEight: "https://newxxy-koa.tibosi.com/", // 给安卓跳转的H5页面
//   baseurNine: "https://oldyyptapi.tibosi.com", // 给旧版运营平台跳转的页面
//   baseurNewWord:'https://khywordpdfapit.tibosi.com', // 新word上传题库
//   baseurXxy:'https://xxyapit.tibosi.com', // 测试站学习云
// };

const BASEUrl = {
  // 正式环境
  // 创建axios实例
  // 20251104改为如果不指定就默认为本域
  baseurOne: process.env.VUE_APP_BASE_URL_ONE || '',
  baseurTwo: process.env.VUE_APP_EXPORT_WORD_URL ||  "https://exportword.tibosi.com",
  baseurTwos: process.env.VUE_APP_EXPORT_WORD_URL || "https://exportword.tibosi.com",
  //导出试卷的实例
  baseurThree: "https://verifycode.tibosi.com",
  baseurFour: "http://121.40.220.32:8284",
  baseurFive: process.env.VUE_APP_BASE_URL_ONE || '',
  baseTraining: "http://121.40.220.32:8284/operation-service",
  baseurEight: "https://newxxy-koa.tibosi.com/", // 给安卓跳转的H5页面
  baseurNine: "https://oldyyptapi.tibosi.com", // 给旧版运营平台跳转的页面
  baseurNewWord:'https://khywordpdfapi.tibosi.com', // 新word上传题库
  baseurXxy:'https://xxyapi.tibosi.com', // 测试站学习云
};
// 创建axios实例
const request = axios.create({
  timeout: 60000,
  baseURL: BASEUrl.baseurOne
});

// 是否连接和使用加密代理
const useEncryptionProxy = process.env.VUE_APP_USE_ENCRYPTION_PROXY === 'true';

// 加密代理外挂
const encryptProxyClient = new EncryptProxyClient({
  baseURL: BASEUrl.baseurOne,
  whitelistUrlPatterns:[
    '/api/userCenter/questionFeedback/questionFeedback',
    'buriedPointResource',
    'Excel'
  ],
  debug: false,
})

//组卷axios实例  特殊不拦截的实例
const zujuanrequest = axios.create({
  baseURL: BASEUrl.baseurOne
});

// 组卷请求也进行加密
if(useEncryptionProxy){
  encryptProxyClient.setupRequestInterceptor(zujuanrequest);
  encryptProxyClient.setupResponseInterceptor(zujuanrequest);
}

//
const request4 = axios.create({
  timeout: 30000,
  baseURL: BASEUrl.baseurOne,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
  } //post请求头部，默认将请求数据作json向后端传送；多数情况后端希望是"x-www-form-urlencoded"格式。大家视实际情况而变
});
//图片验证码的实例
const request2 = axios.create({
  timeout: 30000,
  baseURL: BASEUrl.baseurThree
});
//导出试卷的实例
const request3 = axios.create({
  timeout: 600000,
  baseURL: BASEUrl.baseurTwo
});
const request5 = axios.create({
  timeout: 30000,
  baseURL: BASEUrl.baseurFour
});
// 调运营平台接口
const request7 = axios.create({
  timeout: 30000, // 用于批改试卷的成绩导出
  baseURL: BASEUrl.baseTraining
});
// 给学习云调用H5修改后接口
const request8 = axios.create({
  timeout: 30000, // 用于批改试卷的成绩导出
  baseURL: BASEUrl.baseurEight
});
const request9 = axios.create({
  timeout: 600000, // 用于批改试卷的成绩导出
  baseURL: BASEUrl.baseurTwos
});
const request99 = axios.create({
  timeout: 30000, // 用于旧版运营平台跳转查看
  baseURL: BASEUrl.baseurNine
});
const request66 = axios.create({
  timeout: 60000, // 用于批改试卷的成绩导出
  baseURL: BASEUrl.baseurNewWord
});
const requestXxy = axios.create({
  timeout: 60000, // 用于批改试卷的成绩导出
  baseURL: BASEUrl.baseurXxy
});

if (useEncryptionProxy) {
  // 先执行业务拦截，再进行数据加解密拦截(axios请求拦截是逆序)
  encryptProxyClient.setupRequestInterceptor(request);
}


/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 //请求拦截一般会有哪些操作
  // 1.比如config中的一些信息不符合服务器的要求,这里可以做一些修改
  // 2.比如每次发送网络请求时,都希望在界面中显示一个请求的图标(然后再响应拦截中取消显示)
  // 3.某些网络请求必须携带一些特殊的信息(如登录token),如果没有携带就可以拦截并作响应提示

  // 给请求头添加token
  /*
  * 其中   /.*csrftoken=([^;.]*).*$/    是一个正则表达式，用于从cookie中获取csrftoken的值 ，
  * ([^;.]*) 是命名捕获，表示从匹配到的内容中 只获得 ()内的值。
  * string.match(regex) 得到的是一个数组， 第0项是匹配到的全部内容，第1项是通过命名捕获得到的内容，在这里就是csrftoken的值。
  * 这样就完成了使用axios发送请求的正确配置了，同时保证了网站免受csrf攻击的影响.
  */
request.interceptors.request.use(
  config => {
    // 登录流程控制中，根据本地是否存在token判断用户的登录情况
    // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
    // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
    // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
    //  console.log(config);
    if (config.url == "/api/user/login/login") {
      // nProgress.start();
      return config;
    } else {
      //  const token = store.state.token;
      //    token && (config.headers.Authorization = token);
      if (config.method == "post") {
        let token = JSON.parse(localStorage.getItem("userlist"));
        //非登陆接口必须携带token 格式为 Bearer token
        if (config.data instanceof FormData == true) {
          // FormData格式直接放行，兼容老代码
          return config;
        }
        if (token) {
          if(typeof config.data === "object" && !config.data.userID){
            config.data.userID = token.userID
          }
          if(typeof config.data === "object" && !config.data.guid){
            config.data.guid = token.guid
          }
          if (typeof config.data === "object") {
            let parms = new URLSearchParams();
            for (let key in config.data) {
              if (Array.isArray(config.data[key]) == true) {
                parms.append(key, JSON.stringify(config.data[key]));
              } else {
                parms.append(key, config.data[key]);
              }
            }
            config.data = parms;
          }
          // config
        }
      }
      return config;
    }
  },
  error => {
    console.error("发起请求错误：", error);
    return Promise.reject(error);
  }
);


request99.interceptors.request.use(
  config => {
    if (config.method == "post") {
      let token = JSON.parse(sessionStorage.getItem("old_yyptToken"));
      //非登陆接口必须携带token 格式为 Bearer token
      if (token) {
        config.data.userID = token.userID;
        config.data.guid = token.guid;
        let parms = new URLSearchParams();
        for (let key in config.data) {
          if (Array.isArray(config.data[key]) == true) {
            parms.append(key, JSON.stringify(config.data[key]));
          } else {
            parms.append(key, config.data[key]);
          }
        }
        config.data = parms;
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

if (useEncryptionProxy) {
  // 先执行解密拦截，再进行业务拦截
  encryptProxyClient.setupResponseInterceptor(request);
}

// 响应拦截器
request.interceptors.response.use(
  // 请求成功
  res => {
    // console.log(res);
    // if(res.data.Status == 401){
    //   MessageBox.alert(response.data.respDesc, "您的帐号在另一地点登录，您被迫下线。如果这不是您本人操作，请注意帐号安全。", {
    //     confirmButtonText: "确定",
    //     callback: action => {
    //       // 跳转登录页
    //       Router.push({path:'/login'})
    //     }
    //   });
    // }
    return res;
  },
  // 请求失败
  error => {
    // console.log(error, "?????");
    if (error.response.status == 301) {
      // 登录异常状态改成301
      const txt = error.response.data.Data
        ? error.response.data.Data
        : "网络异常";
      MessageBox.alert(txt, "温馨提示", {
        confirmButtonText: "确定",
        callback: action => {
          // 跳转登录页
          window.location.href = "/#/login";
          window.name = ""; // 清除初始系统弹窗提示状态
          window.location.reload();
        }
      });
    } else if (Number(error.response.status) > 300) {
      MessageBox.alert(
        `错判信息：${error.response.data.Msg +
          error.response.data.Data}<br/>接口地址：${error.config.url}`,
        "温馨提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          callback: action => {}
        }
      );
    }

    return;
    console.log(error);
    console.log(String(error).indexOf("401") != -1);
    if (String(error).indexOf("401") != -1) {
      MessageBox.alert(
        "您的帐号在另一地点登录，您被迫下线。如果这不是您本人操作，请注意帐号安全。",
        "温馨提示",
        {
          confirmButtonText: "确定",
          callback: action => {
            // 跳转登录页
            window.location.href = "/#/login";
          }
        }
      );
    }
    // const { response } = error;
    // if (response) {
    //     // 请求已发出，但是不在2xx的范围
    //     errorHandle(response.status, response.data.message);
    //     return Promise.reject(response);
    // } else {
    //     // 处理断网的情况
    //     // eg:请求超时或断网时，更新state的network状态
    //     // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
    //     // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
    //     if (!window.navigator.onLine) {
    //        store.commit('changeNetwork', false);
    //     } else {
    //         return Promise.reject(error);
    //     }
    // }
  }
);
export {
  request,
  request2,
  request3,
  request4,
  BASEUrl,
  request5,
  zujuanrequest,
  request7,
  request8,
  request9,
  request99,
  request66,
  requestXxy
};
